import React from 'react';

export default function CalculatorForm({ calcium, setCalcium, albumin, setAlbumin, isSI, setIsSI }) {
  return (
    <div className="calculator-form">
      <div className="form-heading">
        <h2>Informe os valores do exame</h2>
        <label className="unit-switch">
          <span className={!isSI ? 'unit-active' : ''}>mg/dL</span>
          <button
            type="button"
            role="switch"
            aria-label="Alternar unidades do Sistema Internacional"
            aria-checked={isSI}
            onClick={() => setIsSI(!isSI)}
            className={`switch-track ${isSI ? 'switch-on' : ''}`}
          >
            <span />
          </button>
          <span className={isSI ? 'unit-active' : ''}>SI</span>
        </label>
      </div>
      <div className="form-fields">
        <div className="field-group">
          <label htmlFor="calcium-input">Cálcio total</label>
          <div className="input-shell">
            <input
              id="calcium-input"
              type="number"
              step="0.01"
              value={calcium}
              onChange={(e) => setCalcium(e.target.value)}
              placeholder={isSI ? 'Ex: 2.2' : 'Ex: 8.5'}
              inputMode="decimal"
            />
            <span>{isSI ? 'mmol/L' : 'mg/dL'}</span>
          </div>
        </div>
        <div className="field-group">
          <label htmlFor="albumin-input">Albumina</label>
          <div className="input-shell">
            <input
              id="albumin-input"
              type="number"
              step="0.1"
              value={albumin}
              onChange={(e) => setAlbumin(e.target.value)}
              placeholder={isSI ? 'Ex: 40' : 'Ex: 4.0'}
              inputMode="decimal"
            />
            <span>{isSI ? 'g/L' : 'g/dL'}</span>
          </div>
        </div>
      </div>
      <p className="form-footnote">Informe os valores nas unidades indicadas no exame.</p>
    </div>
  );
}
